import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedVideos from './components/FeaturedVideos';
import CategoryGrid from './components/CategoryGrid';
import DownloadCTA from './components/DownloadCTA';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '蘑菇视频',
      url: 'https://www.moguvideo.com',
      description: '蘑菇视频是一款深受用户喜爱的短视频娱乐平台，海量高清视频内容随心看，涵盖搞笑、生活、美食、时尚等多元频道。',
      sameAs: [
        'https://weibo.com/moguvideo',
        'https://www.douyin.com/user/moguvideo',
      ],
    },
    {
      '@type': 'WebSite',
      name: '蘑菇视频',
      url: 'https://www.moguvideo.com',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.moguvideo.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '蘑菇视频-短视频娱乐平台官方入口',
      description: '蘑菇视频是一款深受用户喜爱的短视频娱乐平台，海量高清视频内容随心看，涵盖搞笑、生活、美食、时尚等多元频道。立即体验蘑菇视频，发现更多精彩内容，下载App开启你的视频新世界。',
      url: 'https://www.moguvideo.com/',
      isPartOf: { '@id': 'https://www.moguvideo.com/#website' },
      about: { '@id': 'https://www.moguvideo.com/#organization' },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=A%20warm%20gradient%20abstract%20background%20with%20soft%20overlapping%20circles%20in%20coral%20orange%20and%20cream%20tones%2C%20modern%20minimalist%20design%2C%20smooth%20textures%2C%20gentle%20color%20transitions&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '蘑菇视频是免费的吗？',
          acceptedAnswer: { '@type': 'Answer', text: '是的，蘑菇视频完全免费！您可以免费观看平台上的所有短视频内容。部分高清内容和独家频道可能需要注册账号后观看，但基础观看体验完全不需要付费。' },
        },
        {
          '@type': 'Question',
          name: '如何在蘑菇视频上发布自己的视频？',
          acceptedAnswer: { '@type': 'Answer', text: '下载蘑菇视频App并注册账号后，点击底部"+"按钮即可拍摄或上传您的视频。蘑菇视频支持最长5分钟的视频上传，您可以添加滤镜、音乐和特效来丰富您的视频内容。' },
        },
        {
          '@type': 'Question',
          name: '蘑菇视频支持哪些设备？',
          acceptedAnswer: { '@type': 'Answer', text: '蘑菇视频支持iOS和Android移动设备，您可以在App Store和各大安卓应用商店下载。同时，蘑菇视频官网也支持在线观看，无需下载即可在电脑浏览器上浏览精彩内容。' },
        },
        {
          '@type': 'Question',
          name: '视频加载很慢怎么办？',
          acceptedAnswer: { '@type': 'Answer', text: '如果遇到视频加载缓慢的情况，建议您检查网络连接状态，或尝试切换至WiFi网络。您也可以在设置中调整视频清晰度为标清模式，以获得更流畅的播放体验。' },
        },
        {
          '@type': 'Question',
          name: '如何联系蘑菇视频客服？',
          acceptedAnswer: { '@type': 'Answer', text: '您可以通过以下方式联系我们：1) App内"我的-帮助与反馈"提交问题；2) 发送邮件至 support@moguvideo.com；3) 访问蘑菇视频官网"关于我们"页面填写联系表单。我们的客服团队会在24小时内回复您。' },
        },
        {
          '@type': 'Question',
          name: '蘑菇视频有什么特色功能？',
          acceptedAnswer: { '@type': 'Answer', text: '蘑菇视频拥有智能推荐算法，根据您的观看偏好精准推荐感兴趣的视频内容。此外还有离线下载、弹幕互动、视频合拍、直播打赏等丰富功能，让您的观看体验更加有趣和个性化。' },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="蘑菇视频-短视频娱乐平台官方入口 | 蘑菇视频App下载"
        description="蘑菇视频是一款深受用户喜爱的短视频娱乐平台，海量高清视频内容随心看，涵盖搞笑、生活、美食、时尚等多元频道。立即体验蘑菇视频，发现更多精彩内容，下载App开启你的视频新世界。"
        keywords="蘑菇视频,蘑菇视频App下载,蘑菇视频官网,蘑菇视频短视频,蘑菇视频在线观看,蘑菇视频最新版本,蘑菇视频热门内容"
        canonicalUrl="https://www.moguvideo.com/"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedVideos />
        <CategoryGrid />
        <DownloadCTA />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}